import DrawRequestWrapper from './DrawRequestWrapper';
import CreateDrawMessage from './CreateDrawMessage';

export default function WrappedCreateDrawMessage() {
  return (
    <DrawRequestWrapper>
      <CreateDrawMessage />
    </DrawRequestWrapper>
  );
}
